import React, { PureComponent, Fragment } from 'react';
import PropTypes from 'prop-types';
import { FormEditButton, FormPreviewButton, FormSaveButton, FormDuplicateButton, FormCancelButton } from 'data/components';

class FormActionsButtons extends PureComponent {
    static propTypes = {
        formDisabled: PropTypes.bool.isRequired,
        sendLoading: PropTypes.bool.isRequired,
        duplicateRights: PropTypes.bool.isRequired,
        updateRights: PropTypes.bool.isRequired,
        duplicate: PropTypes.bool.isRequired,
        handleEdit: PropTypes.func.isRequired,
        handleCancel: PropTypes.func.isRequired,
        confirmEdit: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
        confirmSave: PropTypes.func.isRequired,
        confirmDuplicate: PropTypes.func.isRequired,
        togglePreview: PropTypes.func.isRequired
    };

    static defaultProps = {};

    render() {
        const {
            duplicateRights,
            updateRights,
            handleCancel,
            formDisabled,
            handleEdit,
            confirmEdit,
            confirmSave,
            sendLoading,
            confirmDuplicate,
            togglePreview,
            type,
            duplicate
        } = this.props;
        return (
            <Fragment>
                {duplicate && duplicateRights ? (
                    <FormDuplicateButton sendFunc={confirmDuplicate} />
                ) : type === 'add' || type === 'duplicate' ? (
                    <Fragment>
                        <FormCancelButton handleCancel={handleCancel} sendLoading={sendLoading} />
                        <FormSaveButton sendFunc={confirmSave} sendLoading={sendLoading} />
                    </Fragment>
                ) : type === 'update' && updateRights ? (
                    <FormEditButton formDisabled={formDisabled} handleEdit={handleEdit} confirmEdit={confirmEdit} sendLoading={sendLoading} />
                ) : null}
                <FormPreviewButton sendFunc={togglePreview} move={!formDisabled} />
            </Fragment>
        );
    }
}

export default FormActionsButtons;



// WEBPACK FOOTER //
// ./environments/fhe/scenes/Notification/components/FormActionsButtons.js